import React, { useState } from "react";
import { defaultDisplayProperties, InsightsDisplayContext, InsightsDisplayProperty, InsightsSortSlug, InsightsViewMode } from "./types";

function InsightsDisplayProvider({ children }) {
  const [viewMode, setViewMode] = useState<InsightsViewMode>("cards");
  const [displayCols, setDisplayCols] = useState<InsightsDisplayProperty[]>(
    defaultDisplayProperties
  );
  const [sortBy, setSort] = useState<InsightsSortSlug>("rank");
  const [showShortlisted, setShowShortlisted] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  // Simulate the effect of changes on the dirty state
  React.useEffect(() => {
    setIsDirty(true);
  }, [viewMode, displayCols, sortBy, showShortlisted]);

  const persist = () => {
    // Would persist to localStorage in full implementation
    setIsDirty(false);
  };

  const reset = () => {
    setViewMode("cards");
    setDisplayCols(defaultDisplayProperties);
    setSort("rank");
    setShowShortlisted(false);
    setIsDirty(false);
  };

  return (
    <InsightsDisplayContext.Provider
      value={{
        viewMode,
        setViewMode,
        displayProperties: displayCols,
        setDisplayProperties: setDisplayCols,
        sortBy,
        setSort,
        showShortlisted,
        setShowShortlisted,
        isDirty,
        persist,
        reset,
      }}
    >
      {children}
    </InsightsDisplayContext.Provider>
  );
}

export default React.memo(InsightsDisplayProvider);
